export const ADMIN_BASE_PATH = "/admin";
export const LOGIN_PATH = "/login";

export const LOGOUT_PATH = "/logout";
export const ACCESS_DENIED_PATH = "/access-denied";
export const HOME_PATH = "/";

export const DASHBOARD_PATH = "/dashboard";
export const USER_SETTINGS_PATH = DASHBOARD_PATH + "/user-settings";
export const USER_DETAILS_FORM_PATH = USER_SETTINGS_PATH + "/details";
export const AVATAR_IMAGE_FORM_PATH = USER_SETTINGS_PATH + "/avatar";
export const FRIENDS_INDEX_PATH = "/friends";
export const ADD_FRIEND_PATH = FRIENDS_INDEX_PATH + "/add";
export const CLAIM_FRIENDSHIP_PATH = FRIENDS_INDEX_PATH + "/claim";

export const GAME_SESSIONS_INDEX_PATH = "/game-sessions";
export const CREATE_GAME_SESSION_PATH = "/game-session";

export const PLAYERS_STATISTICS_PATH = "/statistics";

export const GAME_SESSION_DETAILS_PATH = "/game-session/$gameSessionId";
export const GAME_SESSION_WATCH_PATH = GAME_SESSION_DETAILS_PATH + "/watch";
export const ADD_TIEBREAK_WIN_PATH = GAME_SESSION_DETAILS_PATH + "/tiebreak-win";
export const FINISH_GAME_SESSION_PATH = GAME_SESSION_DETAILS_PATH + "/finish";
export const CREATE_GAME_PATH = GAME_SESSION_DETAILS_PATH + "/games";

export const GAME_SESSION_GAME_DETAILS_PATH = CREATE_GAME_PATH + "/$gameId";

export const CREATE_ROUND_SCORE_PATH = GAME_SESSION_GAME_DETAILS_PATH + "/rounds";

export const DELETE_ROUND_SCORE_PATH = CREATE_ROUND_SCORE_PATH + "/delete";

export const SET_PASSWORD_PATH = "/set-password/$token";
export const RESET_PASSWORD_PATH = "/reset-password";
